import { render, staticRenderFns } from "./IncentiveToduba.vue?vue&type=template&id=37ffc253&scoped=true"
import script from "./IncentiveToduba.vue?vue&type=script&lang=js"
export * from "./IncentiveToduba.vue?vue&type=script&lang=js"
import style0 from "./IncentiveToduba.vue?vue&type=style&index=0&id=37ffc253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ffc253",
  null
  
)

export default component.exports